/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetAllDailyPriceUpdate,
    SaveDailyPriceUpdateDetails,
    ApproveDailyPriceUpdateDetails,
    GetMarketPriceDetails,
    RejectDailyPriceUpdateDetails,
    GetAllRejectPriceDetails,
    RealizedPriceUpdateDetails,
    GetPerformOrderDetailsForMainOrder,
    GetMappedMarketPrice,
    CheckWeighmentDoneFromPerformOrder
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetAllDailyPriceUpdate(model) {
    const response = await CommonPost('/api/ProductPrice/GetAllDailyPriceUpdate', null, model);
    return response.data;
}

async function SaveDailyPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/SaveDailyPriceUpdateDetails', null, model);
    return response;
}

async function ApproveDailyPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/ApproveDailyPriceUpdateDetails', null, model);
    return response;
}

async function RealizedPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/RealizedPriceUpdateDetails', null, model);
    return response;
}

async function GetMarketPriceDetails(model) {
    const response = await CommonPost('/api/ProductMarketPriceWeb/GetMarketPriceDetailByProductID', null, model);
    return response.data;
}
async function RejectDailyPriceUpdateDetails(model) {
    const response = await CommonPost('/api/ProductPrice/RejectDailyPriceUpdateDetails', null, model);
    return response;
}
async function GetAllRejectPriceDetails(model) {
    const response = await CommonPost('/api/ProductPrice/GetAllRejectPriceDetails', null, model);
    return response.data;
}

async function GetPerformOrderDetailsForMainOrder(date) {
    const response = await CommonGet('/api/OutletOrder/GetPerformOrderDetailsForMainOrder', 'date=' + date);
    return response.data;
}

async function GetMappedMarketPrice(operationEntityID, date) {
    const response = await CommonGet('/api/ProductMarketPriceWeb/GetMappedMarketPrice', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function CheckWeighmentDoneFromPerformOrder(operationEntityID, date) {
    const response = await CommonGet('/api/ProductPrice/CheckWeighmentDoneFromPerformOrder', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}